import {
  type ConversationViewModelFactory,
  type MessagesFeatureOptions,
} from '@/features/messages/index'
import Env from '@/infra/env'
import { MessageApi } from './api/message-api'
import { ConversationStore } from './ConversationStore'
import { ConversationViewModel } from './ConversationViewModel'

export function InternalMessagesFeature(options: MessagesFeatureOptions) {
  const api = new MessageApi({
    token$: options.token$,
    baseURL: Env.MESSAGE_API,
  })

  const conversationStore = new ConversationStore(
    api,
    options.primeWorkspace,
    options.primeUser,
    options.currentUser$,
  )

  // Play sounds when receiving and sending messages.
  conversationStore.incomingMessages$.subscribe(() =>
    options.playSound('GotMessage'),
  )
  conversationStore.sent$.subscribe(() => options.playSound('MessageSent'))

  /**
   * Creates a view model for a conversation.
   */
  const createConversationViewModel: ConversationViewModelFactory = (
    getConversationId,
  ) =>
    new ConversationViewModel(
      getConversationId,
      conversationStore,
      options.pageActivity$,
      options.userActive$,
      options.createSnackbarRetryWrapper,
    )

  return {
    conversationStore,
    createConversationViewModel,
  }
}
